module.exports = __webpack_public_path__ + "static/media/EVERGREEN.ec25df0b.svg";